import React from 'react';
import { Clock, MessageCircle } from 'lucide-react';
import { ATENDENTE_WHATSAPP } from '../../config';

const Spec = ({ label, value }) => (
    <div className="vc-spec">
        <div className="vc-spec__label">{label}</div>
        <div className="vc-spec__value" title={value || ''}>{value || '—'}</div>
    </div>
);

export default function CardInfoCarteira({ userData, walletStatus }) {
    const isExpired = walletStatus === 'expired';
    const isWarning = walletStatus === 'warning';

    const whatsappNumber = ATENDENTE_WHATSAPP;
    const whatsappMessage = encodeURIComponent(
        `Olá! Gostaria de solicitar a renovação da minha carteirinha UNAE. Meu CPF é ${userData?.cpf}.`
    );
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

    return (
        <>
            {isWarning && (
                <div className="vc-soon">
                    <div className="vc-soon__head">
                        <div className="vc-soon__ic"><Clock size={20} /></div>
                        <div>
                            <div className="vc-soon__title">Renovação próxima</div>
                            <div className="vc-soon__tag">Prazo se aproximando</div>
                        </div>
                    </div>
                    <p className="vc-soon__text">
                        O prazo de validade da sua carteirinha está chegando. Renove para manter a meia-entrada e os benefícios estudantis ativos.
                    </p>
                    <a className="vc-soon__btn" href={whatsappUrl} target="_blank" rel="noreferrer">
                        <MessageCircle size={18} strokeWidth={2.5} />
                        Renovar agora
                    </a>
                </div>
            )}
            {/* Vencida: documento indisponível — não exibe os dados da carteirinha. */}
            {!isExpired && (
                <div className="vc-specs">
                    <Spec label="Curso" value={userData?.curso} />
                    <Spec label="Instituição" value={userData?.instituicao} />
                    <Spec label="Escolaridade" value={userData?.escolaridade} />
                    <Spec label="Código de uso" value={userData?.codigoUso} />
                    <Spec label="CPF" value={userData?.cpf} />
                    <Spec label="RG" value={userData?.rg} />
                    <Spec label="Nascimento" value={userData?.dataNascimento} />
                    <Spec label="Validade" value={userData?.validadeCarteirinha} />
                </div>
            )}


        </>
    );
}
